import { useEffect, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { CooperProtocol } from '~/modules/aerobicCapabilities/schema'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

export const Cooper: React.FC = () => {
  const data = evaluationAtom.get()
  const [value, setValue] = useState<CooperProtocol>({
    distance: data?.cooper?.distance ?? 0,
  })

  useEffect(() => {
    patchEvaluationAtom({
      cooper: value,
    })
  }, [value])

  return (
    <div>
      <MaskedInput
        mask='integer'
        inputMode='numeric'
        value={value?.distance}
        label='Distância (m)'
        placeholder='0'
        onChange={(e) => {
          setValue({
            distance: e,
          })
        }}
      />
    </div>
  )
}
